import React from 'react';
import {
  Box, Typography, TextField, FormControl,
  InputLabel, Select, MenuItem, Button,
} from '@mui/material';

const MOCK_OS = ['OSDE', 'Swiss Medical', 'Galeno', 'IOMA', 'Medifé'];

// ─── Separador de sección mejorado ──────────────────────────────────────────
function SecDiv({ title, first = false }) {
  return (
    <Box sx={{
      display: 'flex', alignItems: 'center', gap: 1,
      pt: first ? 0 : '16px',
      mt: first ? 0 : '4px',
      borderTop: first ? 'none' : '1px solid rgba(144,202,249,0.12)',
      mb: '6px',
    }}>
      <Typography sx={{
        fontSize: 10, fontWeight: 700, color: '#64748b',
        textTransform: 'uppercase', letterSpacing: 1.2,
        lineHeight: 1, whiteSpace: 'nowrap',
      }}>
        {title}
      </Typography>
      <Box sx={{ flex: 1, height: '1px', bgcolor: 'rgba(144,202,249,0.08)' }} />
    </Box>
  );
}

// ─── Card de cobertura médica ────────────────────────────────────────────────
function CoberturaCard({ children }) {
  return (
    <Box sx={{
      border: '1px solid rgba(144,202,249,0.12)',
      borderRadius: '6px',
      bgcolor: 'rgba(144,202,249,0.025)',
      p: '12px',
    }}>
      {children}
    </Box>
  );
}

// ─── Fondo de campo compartido ───────────────────────────────────────────────
const inputRoot = {
  bgcolor: '#111c2e !important',
  color: '#e0e0e0',
  '& fieldset': { borderColor: 'rgba(144,202,249,0.2)' },
  '&:hover fieldset': { borderColor: 'rgba(144,202,249,0.4)' },
  '&.Mui-focused fieldset': { borderColor: '#90caf9' },
};

// ─── OPCIÓN A: Floating labels MUI ──────────────────────────────────────────
const fSxA = {
  '& .MuiOutlinedInput-root': inputRoot,
};
const lblA = {
  sx: {
    color: '#90caf9',
    '&.MuiInputLabel-shrink': {
      color: '#90caf9',
      bgcolor: '#111c2e',
      px: '4px',
      borderRadius: '2px',
    },
  },
};

function FormA() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <SecDiv title="Identificación" first />
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', mb: '10px' }}>
        <TextField label="Nombre *" size="small" fullWidth sx={fSxA} InputLabelProps={lblA} />
        <TextField label="Apellido"  size="small" fullWidth sx={fSxA} InputLabelProps={lblA} />
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
        <TextField label="DNI" size="small" fullWidth sx={fSxA} InputLabelProps={lblA} />
        <TextField label="Fecha de nacimiento" type="date" size="small" fullWidth sx={fSxA}
          InputLabelProps={{ shrink: true, sx: { color: '#90caf9', bgcolor: '#111c2e', px: '4px', borderRadius: '2px' } }} />
      </Box>

      <SecDiv title="Contacto" />
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', mb: '10px' }}>
        <TextField label="Email"    size="small" fullWidth sx={fSxA} InputLabelProps={lblA} />
        <TextField label="Teléfono" size="small" fullWidth sx={fSxA} InputLabelProps={lblA} />
      </Box>
      <TextField label="Dirección" size="small" fullWidth sx={fSxA} InputLabelProps={lblA} />

      <SecDiv title="Cobertura médica" />
      <CoberturaCard>
        <Box sx={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '10px' }}>
          <FormControl size="small" fullWidth sx={fSxA}>
            <InputLabel shrink sx={{ color: '#90caf9', bgcolor: '#111c2e', px: '4px', borderRadius: '2px' }}>
              Obra social
            </InputLabel>
            <Select notched label="Obra social" defaultValue="" sx={{ color: '#e0e0e0', bgcolor: '#111c2e !important' }}>
              <MenuItem value=""><em style={{ color: '#888' }}>Sin especificar</em></MenuItem>
              {MOCK_OS.map(os => <MenuItem key={os} value={os}>{os}</MenuItem>)}
            </Select>
          </FormControl>
          <TextField label="N° afiliado" size="small" fullWidth sx={fSxA} InputLabelProps={lblA} />
        </Box>
      </CoberturaCard>
    </Box>
  );
}

// ─── OPCIÓN B: Labels externos ───────────────────────────────────────────────
const fSxB = { '& .MuiOutlinedInput-root': inputRoot };
const lblExtStyle = {
  fontSize: 11, fontWeight: 500, color: '#90caf9',
  mb: '4px', display: 'block',
};

function LF({ label, children }) {
  return (
    <Box>
      <Typography component="span" sx={lblExtStyle}>{label}</Typography>
      {children}
    </Box>
  );
}

function FormB() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <SecDiv title="Identificación" first />
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', mb: '10px' }}>
        <LF label="Nombre *"><TextField size="small" fullWidth sx={fSxB} /></LF>
        <LF label="Apellido"><TextField  size="small" fullWidth sx={fSxB} /></LF>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
        <LF label="DNI"><TextField size="small" fullWidth sx={fSxB} /></LF>
        <LF label="Fecha de nacimiento">
          <TextField type="date" size="small" fullWidth sx={fSxB} />
        </LF>
      </Box>

      <SecDiv title="Contacto" />
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', mb: '10px' }}>
        <LF label="Email"><TextField    size="small" fullWidth sx={fSxB} /></LF>
        <LF label="Teléfono"><TextField size="small" fullWidth sx={fSxB} /></LF>
      </Box>
      <LF label="Dirección"><TextField size="small" fullWidth sx={fSxB} /></LF>

      <SecDiv title="Cobertura médica" />
      <CoberturaCard>
        <Box sx={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '10px' }}>
          <LF label="Obra social">
            <FormControl size="small" fullWidth sx={fSxB}>
              <Select defaultValue="" sx={{ color: '#e0e0e0', bgcolor: '#111c2e !important' }}>
                <MenuItem value=""><em style={{ color: '#888' }}>Sin especificar</em></MenuItem>
                {MOCK_OS.map(os => <MenuItem key={os} value={os}>{os}</MenuItem>)}
              </Select>
            </FormControl>
          </LF>
          <LF label="N° afiliado"><TextField size="small" fullWidth sx={fSxB} /></LF>
        </Box>
      </CoberturaCard>
    </Box>
  );
}

// ─── Wrapper que simula el dialog ────────────────────────────────────────────
function DialogCard({ label, labelColor, description, children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', width: 460 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ bgcolor: labelColor, color: '#fff', px: '10px', py: '3px', borderRadius: '4px', fontSize: 12, fontWeight: 700 }}>
          {label}
        </Box>
        <Typography sx={{ color: '#e0e0e0', fontSize: 13, fontWeight: 600 }}>{description}</Typography>
      </Box>
      <Box sx={{
        bgcolor: '#16213e', borderRadius: 2, overflow: 'hidden',
        border: '1px solid rgba(144,202,249,0.12)',
        display: 'flex', flexDirection: 'column',
      }}>
        {/* Header simplificado — sin subtitle */}
        <Box sx={{ bgcolor: '#1a2744', px: '20px', py: '16px', borderBottom: '1px solid rgba(144,202,249,0.08)' }}>
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#e0e0e0' }}>Nuevo paciente</Typography>
        </Box>

        {/* Contenido */}
        <Box sx={{ px: '20px', py: '20px' }}>
          {children}
        </Box>

        {/* Footer compacto */}
        <Box sx={{
          bgcolor: '#131e36', px: '20px', py: '10px',
          borderTop: '1px solid rgba(144,202,249,0.08)',
          display: 'flex', justifyContent: 'flex-end', gap: 1,
        }}>
          <Button sx={{ color: '#90caf9', fontSize: 13 }}>Cancelar</Button>
          <Button variant="contained" sx={{ bgcolor: '#1e56a0', color: '#fff', fontSize: 13, fontWeight: 600 }}>
            Crear paciente
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

// ─── Página principal ────────────────────────────────────────────────────────
export default function DesignCompare() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#0f1629', p: '40px' }}>
      <Typography sx={{ color: '#90caf9', fontSize: 22, fontWeight: 700, mb: 1 }}>
        Gestar — Comparación de variantes
      </Typography>
      <Typography sx={{ color: '#475569', fontSize: 13, mb: '40px', maxWidth: 700 }}>
        Ambas variantes aplican todos los cambios aprobados: campos 40px, separadores de sección con más contraste,
        cobertura médica agrupada, footer compacto, header sin subtitle.
        La única diferencia es el tratamiento de labels.
      </Typography>

      <Box sx={{ display: 'flex', gap: '48px', flexWrap: 'wrap', alignItems: 'flex-start' }}>
        <DialogCard label="A" labelColor="#1e56a0" description="Floating labels (MUI estándar)">
          <FormA />
        </DialogCard>

        <DialogCard label="B" labelColor="#475569" description="Labels externos">
          <FormB />
        </DialogCard>
      </Box>
    </Box>
  );
}
